import { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Skeleton,
  Typography,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import Loading from "../../../../ATS/images/waiting.gif";
import Success from "../../../../ATS/images/confetti.gif";
import {
  convertBase64,
  getUserData,
} from "../../../../Base/helper/baseFunctions";
import {
  GenerateOfferLetterNoHelper,
  GetOfferLetterTemplateResponseHelper,
  OfferEmailSentHelper,
  UpdateOfferLetterTemplateResponseHelper,

} from "../../../helper/AtsFormTemplateResponseHelper";
import {
  GetOfferLetterTemplateHelper,
  OfferLetterFieldsHelper,
} from "../../../helper/AtsFormTemplateHelper";
import { GetAtsJobKanbanOfferHelper } from "../../../../ATS/helper/AtsJobKanbanHelper";
import Popup from "../../../../Base/views/Popup";
import "../../../css/preview.css"
import "../../../css/style.css"
import {useDispatch} from "react-redux";
import {
  AddOfferLetterTemplateResponseAction,
  UpdateOfferLetterTemplateResponseAction,
} from "../../../../../../store/ATS/FormTemplate/Action";
import OfferLetterDocumentEditor, {
  generateOfferLetterPdf,
  parseOfferLetterContent,
} from "../editor/OfferLetterDocumentEditor";
import { buildCandidateSalaryFieldValues } from "../editor/editorDocxUtils";
import { GetCompanySignedLogoHelper } from "../../../../Ancillary/CompanyDetails/helper/CompanyDetailsHelper";
import "../../../css/style.css";

const Completeoffer = ({
  currentData,
  currentJobData,
  resData,
  setIsOfferForm,
  setElements,
  OfferEdit,
  setCurrentData,
  companylogo,
  letterHeadData,
  setActiveStep,
  payConfigResponse,
  isConfigureCtc,
}) => {
  const dispatch = useDispatch();
  const [candidateData, setCandidateData] = useState({});
  const [templateData, setTemplateData] = useState(null);
  const [templateFields, setTemplateFields] = useState([]);
  const [viewMode, setViewMode] = useState("Loading");
  const [description, setDescription] = useState("");
  const [step, setStep] = useState(1);
  const [offerLoading, setOfferLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [imageSrc, setImageSrc] = useState(Loading);
  const [message, setMessage] = useState(
    "Your personalized offer letter is being prepared. Please hold tight!"
  );
  const [logoUrl, setLogoUrl] = useState(companylogo || "");
  const documentEditorRef = useRef(null);
  const userData = getUserData();

  useEffect(() => {
    if (companylogo) {
      setLogoUrl(companylogo);
    } else {
      GetCompanySignedLogoHelper()
        .then((res) => {
          if (res?.signedUrl) {
            setLogoUrl(res.signedUrl);
          } else if (res?.data?.data?.[0]?.companylogo) {
            setLogoUrl(res.data.data[0].companylogo);
          }
        })
        .catch(() => {});
    }
  }, [companylogo]);

  const payConfigHtml = payConfigResponse?.payconfig_content || "";

  useEffect(() => {
    if (resData?.offer_letter_response_id) {
      GetOfferLetterTemplateResponseHelper({
        workspace: userData?.domain,
        offer_letter_response_id: resData?.offer_letter_response_id,
      }).then((res) => {
        const item = res?.data?.data?.[0];
        setCandidateData(item || {});
        if (item?.offer_letter_template_fields) {
          setTemplateFields(item.offer_letter_template_fields);
        }
        const desc =
          item?.offer_letter_edited ||
          item?.offer_letter_response ||
          "";
        if (OfferEdit !== "true") {
          setDescription(desc);
        }
        setViewMode("Feedback");

        const tId = item?.offer_letter_template_id || currentJobData?.offer_letter_template_id;
        if (tId) {
          OfferLetterFieldsHelper({ offer_letter_template_id: tId }).then((fRes) => {
            if (fRes?.data?.statuscode === 200 && Array.isArray(fRes?.data?.data)) {
              setTemplateFields(fRes.data.data);
            }
          });
          GetOfferLetterTemplateHelper({
            workspace: userData?.domain,
            offer_letter_template_id: tId,
          }).then((tRes) => {
            const template = tRes?.data?.data?.[0] || null;
            setTemplateData(template);
            if (OfferEdit === "true") {
              setDescription(template?.offer_letter_content || desc);
            }
          });
        }
      });
    } else if (currentJobData?.offer_letter_template_id) {
      const tId = currentJobData?.offer_letter_template_id;
      OfferLetterFieldsHelper({ offer_letter_template_id: tId }).then((fRes) => {
        if (fRes?.data?.statuscode === 200 && Array.isArray(fRes?.data?.data)) {
          setTemplateFields(fRes.data.data);
        }
      });
      GetOfferLetterTemplateHelper({
        workspace: userData?.domain,
        offer_letter_template_id: tId,
      }).then((tRes) => {
        const template = tRes?.data?.data?.[0];
        setTemplateData(template);
        let content = template?.offer_letter_content;
        const fields = resData?.offer_letter_fields_response;
        if (typeof content === "string" && fields) {
          for (const key in fields) {
            content = content.split(key).join(fields[key]);
          }
        }
        setDescription(content);
        setCandidateData(resData);
        setViewMode("Feedback");
      });
    } else {
      setViewMode("Feedback");
    }
    //eslint-disable-next-line
  }, [resData]);

  const parsed = parseOfferLetterContent(description);
  const isLetterheadMode = Boolean(
    candidateData?.is_letterhead ||
    templateData?.is_letterhead ||
    parsed?.header_footer_mode === "LETTERHEAD"
  );

  let fieldValues = {};
  try {
    const rawFields = resData?.offer_letter_fields_response || candidateData?.offer_letter_fields_response;
    fieldValues = typeof rawFields === "string" ? JSON.parse(rawFields) : (rawFields || {});
  } catch (e) {}

  let payConfigInput = null;
  try {
    const rawPayJson = payConfigResponse?.payconfig_input_json || candidateData?.payconfig_input_json;
    payConfigInput = typeof rawPayJson === "string" ? JSON.parse(rawPayJson) : (rawPayJson || null);
  } catch (e) {}

  const isCtcZero = isConfigureCtc === false || Boolean(
    payConfigInput && (
      (Number(payConfigInput.ctc) === 0 || payConfigInput.ctc === "0") ||
      (Number(payConfigInput.grossEarningsTempTotalValue || 0) === 0 && Number(payConfigInput.basic || 0) === 0)
    )
  );

  const candidateSalaryFieldValues = buildCandidateSalaryFieldValues(payConfigInput);

  const candidateName = fieldValues?.candidate_name || currentData?.full_name || "";
  if (candidateName && !candidateSalaryFieldValues.candidate_name) {
    candidateSalaryFieldValues.candidate_name = candidateName;
  }

  const offerLetterNo = candidateData?.offer_letter_no || currentData?.offer_letter_no;
  if (offerLetterNo) {
    candidateSalaryFieldValues.offer_letter_no = offerLetterNo;
    candidateSalaryFieldValues["@{offer_letter_no}"] = offerLetterNo;
  }

  const effectiveFieldValues = { ...fieldValues, ...candidateSalaryFieldValues };

  const effectiveLetterHead = Array.isArray(letterHeadData) ? letterHeadData[0] : letterHeadData;
  const effectiveHeader = candidateData?.header || templateData?.header || effectiveLetterHead?.letterhead_header || "";
  const effectiveFooter = candidateData?.footer || templateData?.footer || effectiveLetterHead?.letterhead_footer || "";

  const rawFieldsList =
    templateFields.length > 0
      ? templateFields
      : (candidateData?.offer_letter_template_fields || templateData?.offer_letter_template_fields || []);
  const mentionUsers = rawFieldsList.map((temp) => ({
    ...temp,
    id: temp?.name || temp?.label,
    name: temp?.name || temp?.label,
    label: temp?.label || temp?.name,
    display: temp?.label || temp?.name,
  }));

  const handleEditClick = () => {
    setStep(2);
  };

  const handleDownloadTestPdf = async () => {
    try {
      setDownloading(true);
      await new Promise((resolve) => setTimeout(resolve, 40));
      const activeDocBytes = documentEditorRef.current?.getDocBytes?.() || null;
      const pdf = await generateOfferLetterPdf({
        content: description,
        docBytes: activeDocBytes,
        isLetterhead: isLetterheadMode,
        header_footer_mode: isLetterheadMode ? "LETTERHEAD" : "OUR_HEADER_FOOTER",
        letterHeadData: isLetterheadMode ? effectiveLetterHead : null,
        companylogo: isLetterheadMode ? null : logoUrl,
        headerTitle: isLetterheadMode ? "" : effectiveHeader,
        footerText: isLetterheadMode ? "" : effectiveFooter,
        isCtcZero,
        fieldValues: effectiveFieldValues,
      });

      pdf.save(`offer_letter_preview.pdf`);
    } catch (e) {
      console.error("[Completeoffer] Error downloading preview PDF:", e);
    } finally {
      setDownloading(false);
    }
  };

  const handleOfferComplete = async () => {
    setOfferLoading(true);
    try {
      let finalContent = description;
      if (documentEditorRef.current?.saveDocx) {
        const saved = await documentEditorRef.current.saveDocx();
        if (saved?.packageJson) {
          finalContent = saved.packageJson;
        } else if (saved?.html) {
          finalContent = saved.html;
        }
      }
      const activeDocBytes = documentEditorRef.current?.getDocBytes?.() || null;
      let old_offer_name = candidateData?.offer_letter_cloud_path || "";
      const filename = `${userData?.domain}/ATS/OfferLetters/${uuidv4()}.pdf`;
      const isNewOffer = OfferEdit !== "true" && !candidateData?.offer_letter_response_id;

      let generatedOfferNo = candidateData?.offer_letter_no || "";
      if (isNewOffer && !generatedOfferNo) {
        const numRes = await GenerateOfferLetterNoHelper({
          workspace: userData?.domain,
        });
        if (numRes?.data?.data?.[0]?.offer_letter_no) {
          generatedOfferNo = numRes.data.data[0].offer_letter_no;
        }
      }

      let effectiveValuesForPdf = { ...effectiveFieldValues };
      let effectiveContentForSave = finalContent;
      let effectiveFieldsResponse = { ...resData?.offer_letter_fields_response };

      if (generatedOfferNo) {
        effectiveValuesForPdf.offer_letter_no = generatedOfferNo;
        effectiveValuesForPdf["@{offer_letter_no}"] = generatedOfferNo;

        try {
          let pkg = typeof finalContent === "string" ? JSON.parse(finalContent) : finalContent;
          if (pkg && typeof pkg === "object") {
            if (pkg.html) {
              pkg.html = pkg.html.replace(/@\{offer_letter_no\}/g, generatedOfferNo);
            }
            if (pkg.docxBase64) {
              const { base64ToUint8Array, uint8ArrayToBase64, substituteVariablesInDocxXml } = await import("../editor/editorDocxUtils");
              const JSZip = (await import("jszip")).default || (await import("jszip"));
              const zip = await JSZip.loadAsync(base64ToUint8Array(pkg.docxBase64));
              let docXml = await zip.file("word/document.xml")?.async("text");
              if (docXml) {
                docXml = substituteVariablesInDocxXml(docXml, { offer_letter_no: generatedOfferNo, "@{offer_letter_no}": generatedOfferNo });
                zip.file("word/document.xml", docXml);
                const updatedBytes = await zip.generateAsync({ type: "uint8array" });
                pkg.docxBase64 = uint8ArrayToBase64(updatedBytes);
              }
            }
            effectiveContentForSave = JSON.stringify(pkg);
          } else if (typeof finalContent === "string") {
            effectiveContentForSave = finalContent.replace(/@\{offer_letter_no\}/g, generatedOfferNo);
          }
        } catch (e) {
          if (typeof finalContent === "string") {
            effectiveContentForSave = finalContent.replace(/@\{offer_letter_no\}/g, generatedOfferNo);
          }
        }

        if (typeof document !== "undefined") {
          const editorEl = document.querySelector(".offer-letter-document-editor-container") || document.querySelector(".offer-letter-document-editor");
          if (editorEl) {
            const walker = document.createTreeWalker(editorEl, NodeFilter.SHOW_TEXT, null, false);
            let textNode;
            while ((textNode = walker.nextNode())) {
              if (textNode.nodeValue && textNode.nodeValue.includes("@{offer_letter_no}")) {
                textNode.nodeValue = textNode.nodeValue.split("@{offer_letter_no}").join(generatedOfferNo);
                if (textNode.parentElement && textNode.parentElement.style) {
                  if (textNode.parentElement.style.backgroundColor === "yellow" || textNode.parentElement.style.backgroundColor === "rgb(255, 255, 0)") {
                    textNode.parentElement.style.backgroundColor = "transparent";
                  }
                }
              }
            }
          }
        }
      }

      const pdf = await generateOfferLetterPdf({
        content: effectiveContentForSave,
        docBytes: activeDocBytes,
        isLetterhead: isLetterheadMode,
        header_footer_mode: isLetterheadMode ? "LETTERHEAD" : "OUR_HEADER_FOOTER",
        letterHeadData: isLetterheadMode ? effectiveLetterHead : null,
        companylogo: isLetterheadMode ? null : logoUrl,
        headerTitle: isLetterheadMode ? "" : effectiveHeader,
        footerText: isLetterheadMode ? "" : effectiveFooter,
        isCtcZero,
        fieldValues: effectiveValuesForPdf,
      });

      const pdfBlob = pdf.output("blob");
      const b64string = await convertBase64(pdfBlob);

      if (isNewOffer) {
        dispatch(AddOfferLetterTemplateResponseAction({
          workspace: userData?.domain,
          user_id: userData?.employee_id,
          offer_letter_template_id: currentJobData?.offer_letter_template_id,
          candidate_job_id: currentData?.candidate_job_id,
          offer_letter_fields_response: JSON.stringify(
            effectiveFieldsResponse
          ),
          offer_letter_response: effectiveContentForSave,
          file: b64string,
          file_name: filename,
          offer_letter_no: generatedOfferNo,
          payconfig_input_json: payConfigResponse?.payconfig_input_json ? JSON.stringify(payConfigResponse?.payconfig_input_json) : null,
          payconfig_content: payConfigResponse?.payconfig_content || "",
          is_configure_ctc: isConfigureCtc,
        }, (response, error) => {
          if (response?.data?.statuscode === 200) {
            setMessage("Voila! Your offer letter is ready for viewing.");
            setImageSrc(Success);
            const createdItem = response?.data?.data?.[0];
            setCandidateData(createdItem || {});

            GetAtsJobKanbanOfferHelper({
              ats_jobpost_id: currentJobData?.ats_jobpost_id,
            }).then((res) => {
              res?.data?.data && setElements(res?.data?.data);
              res?.data?.data && setCurrentData((res?.data?.data || []).find(el => +el?.offer_letter_response_id === +createdItem?.offer_letter_response_id));
              setOfferLoading(false);
              setIsOfferForm(false);
            });
          } else {
            setOfferLoading(false);
          }
        }));
      } else {
        dispatch(UpdateOfferLetterTemplateResponseAction({
          workspace: userData?.domain,
          user_id: userData?.employee_id,
          offer_letter_response_id: candidateData?.offer_letter_response_id,
          offer_letter_fields_response: JSON.stringify(
            resData?.offer_letter_fields_response
          ),
          offer_letter_response: finalContent,
          file: b64string,
          file_name: filename,
          old_offer_name: old_offer_name,
          payconfig_input_json: payConfigResponse?.payconfig_input_json ? JSON.stringify(payConfigResponse?.payconfig_input_json) : (candidateData?.payconfig_input_json ? JSON.stringify(candidateData?.payconfig_input_json) : null),
          payconfig_content: payConfigResponse?.payconfig_content || candidateData?.payconfig_content || "",
          is_configure_ctc: isConfigureCtc,
        }, (response, error) => {
          if (response?.data?.statuscode === 200) {
            setMessage("Voila! Your offer letter is ready for viewing.");
            setImageSrc(Success);
            setCandidateData(response?.data?.data[0]);
            if (OfferEdit === "true") {
              OfferEmailSentHelper({
                update_tblcolumn: "approver_response",
                offer_letter_response_id: candidateData?.offer_letter_response_id,
                update_tblcolumn_value: "false",
              });
            }
            GetAtsJobKanbanOfferHelper({
              ats_jobpost_id: currentJobData?.ats_jobpost_id,
            }).then((res) => {
              res?.data?.data && setElements(res?.data?.data);
              res?.data?.data && setCurrentData((res?.data?.data || []).find(el => +el?.offer_letter_response_id === +candidateData?.offer_letter_response_id));
              setOfferLoading(false);
              setIsOfferForm(false);
            });
          } else {
            setOfferLoading(false);
          }
        }));
      }

    } catch (err) {
      console.error("[Completeoffer] Error generating offer letter PDF:", err);
      setOfferLoading(false);
    }
  };

  const handleUpdate = async () => {
    setOfferLoading(true);
    setImageSrc(Loading);
    setMessage("Updating your offer letter, please wait...");
    try {
      let finalContent = description;
      if (documentEditorRef.current?.saveDocx) {
        const saved = await documentEditorRef.current.saveDocx();
        if (saved?.packageJson) {
          finalContent = saved.packageJson;
        } else if (saved?.html) {
          finalContent = saved.html;
        }
      }
      if (!candidateData?.offer_letter_response_id) {
        setDescription(finalContent);
        setStep(1);
        setOfferLoading(false);
        return;
      }
      dispatch(UpdateOfferLetterTemplateResponseAction({
        workspace: userData?.domain,
        user_id: userData?.employee_id,
        offer_letter_response_id: candidateData?.offer_letter_response_id,
        offer_letter_fields_response: JSON.stringify(
          resData?.offer_letter_fields_response
        ),
        offer_letter_response: finalContent,
        file: null,
        file_name: candidateData?.offer_letter_cloud_path,
        payconfig_input_json: payConfigResponse?.payconfig_input_json ? JSON.stringify(payConfigResponse?.payconfig_input_json) : (candidateData?.payconfig_input_json ? JSON.stringify(candidateData?.payconfig_input_json) : null),
        payconfig_content: payConfigResponse?.payconfig_content || candidateData?.payconfig_content || "",
        is_configure_ctc: isConfigureCtc,
      }, (response, error) => {
        setOfferLoading(false);
        if (response?.data?.statuscode === 200) {
          setDescription(finalContent);
          setCandidateData(response?.data?.data[0]);
          setStep(1);
          OfferEmailSentHelper({
            update_tblcolumn: "approver_response",
            offer_letter_response_id: candidateData?.offer_letter_response_id,
            update_tblcolumn_value: "false",
          });
        }
      }));
    } catch (err) {
      setOfferLoading(false);
    }
  };

  return (
    <>
      {viewMode === "Loading" ? (
        <Box sx={{ width: "70%", mx: "auto", marginTop: 2 }}>
          <Box>
            <Skeleton variant="rectangular" width="100%" height={200} />
            <Skeleton variant="rectangular" width="100%" height={200} />
          </Box>
        </Box>
      ) : viewMode === "Feedback" ? (
        <>
          {step === 1 && (
            <Box sx={{ width: "100%", maxWidth: "1000px", mx: "auto" }}>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <Typography sx={{ mb: 1, textAlign: "center", fontWeight: 600 }} variant="h6">
                  Offer Letter Preview
                </Typography>
              </Box>

              <OfferLetterDocumentEditor
                ref={documentEditorRef}
                value={description}
                isCtcZero={isCtcZero}
                fieldValues={effectiveFieldValues}
                mentionUsers={mentionUsers}
                header_footer_mode={isLetterheadMode ? "LETTERHEAD" : "OUR_HEADER_FOOTER"}
                letterHeadData={effectiveLetterHead}
                companylogo={logoUrl}
                headerTitle={effectiveHeader}
                footerText={effectiveFooter}
                mode="view"
                editorTitle="Offer Letter Preview"
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "20px",
                  padding: "10px 0px 40px 0px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <Button
                    variant="contained"
                    className="mpl-primary-btn"
                    onClick={() => setActiveStep((pre) => pre - 1)}
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    className="mpl-primary-btn"
                    onClick={handleEditClick}
                  >
                    Edit
                  </Button>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Button
                    className="mpl-primary-btn"
                    variant="contained"
                    onClick={handleOfferComplete}
                  >
                    Generate Offer Letter
                  </Button>
                </Box>
              </Box>
            </Box>
          )}

          {step === 2 && (
            <Box sx={{ width: "100%", maxWidth: "1000px", mx: "auto" }}>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <Typography sx={{ mb: 1, textAlign: "center", fontWeight: 600 }} variant="h6">
                  Offer Letter Customization
                </Typography>
              </Box>

              <OfferLetterDocumentEditor
                ref={documentEditorRef}
                value={description}
                isCtcZero={isCtcZero}
                fieldValues={effectiveFieldValues}
                mentionUsers={mentionUsers}
                setValue={setDescription}
                header_footer_mode={isLetterheadMode ? "LETTERHEAD" : "OUR_HEADER_FOOTER"}
                letterHeadData={effectiveLetterHead}
                companylogo={logoUrl}
                headerTitle={effectiveHeader}
                footerText={effectiveFooter}
                mode="edit"
                editorTitle="Offer Letter Customization"
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 2,
                  marginTop: "20px",
                  padding: "10px 0px 40px 0px",
                }}
              >
                <Button
                  variant="outlined"
                  sx={{ borderColor: "#cbd5e1", color: "#475569" }}
                  onClick={() => setStep(1)}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  className="mpl-primary-btn"
                  onClick={handleUpdate}
                >
                  Update
                </Button>
              </Box>
            </Box>
          )}
        </>
      ) : null}

      <Popup
        maxWidth="md"
        isMasterProduct={true}
        setOpenPopup={setOfferLoading}
        openPopup={offerLoading}
        close={false}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "600px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "#e6f4ea",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
            padding: "20px",
            margin: "auto",
          }}
        >
          <img
            src={imageSrc}
            alt="Loading..."
            width={"100px"}
            height={"100px"}
            style={{
              backgroundColor: "#fff",
              borderRadius: "50%",
              padding: "10px",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          />
          <Typography sx={{ pt: 1, pb: 1, textAlign: "center" }} variant="h4">
            {message}
          </Typography>
        </Box>
        {message === "Voila! Your offer letter is ready for viewing." && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              className="mpl-primary-btn"
              variant="contained"
              onClick={() => setIsOfferForm(false)}
            >
              Ok
            </Button>
          </Box>
        )}
      </Popup>
    </>
  );
};

export default Completeoffer;